import { apiClient } from "@/lib/api-client"
import type { ExploreRitual, ExploreRitualsFilters, ExploreRitualsResponse } from "../types"

interface ApiResponse<T> {
  success: boolean
  data: T
  message: string
}

/**
 * Get paginated explore rituals with search and filters
 */
export async function getExploreRituals(
  page: number,
  limit: number,
  filters: ExploreRitualsFilters,
): Promise<ExploreRitualsResponse> {
  const params = new URLSearchParams()
  params.append("page", page.toString())
  params.append("limit", limit.toString())

  if (filters.search) params.append("search", filters.search)
  if (filters.sort) params.append("sort", filters.sort)
  if (filters.price) params.append("price", filters.price)
  if (filters.priceRange) {
    params.append("price_min", filters.priceRange[0].toString())
    params.append("price_max", filters.priceRange[1].toString())
  }
  if (filters.format) params.append("format", filters.format)
  if (filters.duration) params.append("duration", filters.duration)
  if (filters.intention) params.append("intention", filters.intention)
  if (filters.intentions) params.append("intentions", filters.intentions)
  if (filters.traditions) params.append("traditions", filters.traditions)
  if (filters.city) params.append("city", filters.city)
  if (filters.state) params.append("state", filters.state)
  if (filters.country) params.append("country", filters.country)
  if (filters.content) params.append("content", filters.content)

  const response = await apiClient.get<ApiResponse<ExploreRitualsResponse>>(
    `/api/rituals/explore?${params.toString()}`,
  )
  return response.data.data
}

/**
 * Get featured rituals for the carousel
 */
export async function getFeaturedRituals(limit: number = 5): Promise<ExploreRitual[]> {
  const response = await apiClient.get<ApiResponse<{ rituals: ExploreRitual[] }>>(
    `/api/rituals/featured?limit=${limit}`,
  )
  return response.data.data.rituals
}

/**
 * Get highlighted ritualists (reuses Connect API)
 */
export async function getHighlightedRitualists(limit: number = 5) {
  const response = await apiClient.get<
    ApiResponse<
      Array<{
        id: string
        name: string
        username: string
        profilePictureUrl: string | null
        ritualCount: number
        bio: string | null
        isFollowing?: boolean
      }>
    >
  >(`/api/connect/highlighted-ritualists?limit=${limit}`)
  return response.data.data
}
